import React from "react";
import { Container, Offcanvas } from "react-bootstrap";
import { MdArrowBackIos } from "react-icons/md";
import { Link } from "react-router-dom";
import "./OffCanvas.scss";
const OffCanvasChild = ({ show2, setShow2, child, setShow, setShowNav }) => {
  return (
    <Container>
      <Offcanvas
        show={show2}
        placement="end"
        style={{ backgroundColor: "#F8F9FA" }}
        className="off_canvas_background"
      >
        <Offcanvas.Header
          onClick={() => {
            setShow2(false);
          }}
          style={{
            cursor: "pointer",
            padding: "0",
            lineHeight: "2.6rem",
            marginTop: "17px",
          }}
        >
          <div className="d-flex align-items-center border-bottom border-top w-100">
            <div
              className="back_button_hover"
              style={{
                height: "47px",
                width: "54px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRight: "1.5px solid #e8e8e8",
              }}
            >
              <MdArrowBackIos style={{}} />
            </div>

            <div
              className="ps-3 text-uppercase d-flex align-items-center"
              style={{
                width: "100%",
                height: "50px",
                color: "#08c",
                fontWeight: "600",
              }}
            >
              {child?.title}
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ padding: "0" }}>
          {child?.children?.length > 0 &&
            child?.children?.map((children) => (
              <Link
                key={children._id}
                onClick={() => {
                  setShow2(false);
                  setShow(false);
                  setShowNav(false);
                }}
                to={`/category/children/${children?._id}`}
                className="off_canvas_link"
                style={{
                  fontSize: "0.875rem",
                  letterSpacing: "0.125rem",
                  lineHeight: "3rem",
                  borderBottom: "1px solid #e8e8e8",
                  textTransform: "uppercase",
                  paddingLeft: "70px",
                  display: "block",
                  color: "black",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                {children.title}
              </Link>
            ))}
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
};

export default OffCanvasChild;
